import React from 'react';
import { Container, Button } from 'reactstrap';
import validationConfig from './validation-config';
import FormValidator from '../../../utils/FormValidator';
import TextInput, {
  filterNumericKeyPress,
  generatePhoneNumberHandler,
} from '../../../components/TextInput';
import CompanyLogo from '../../../components/CompanyLogo';
import Loader from '../../../components/Loader';

import styles from './PerfonalInfoForm.module.scss';

const renderClientLoanReferenceId = (props) => {
  const referenceIdProvided = !!props.loanReferenceId;
  return (
    <TextInput
      name="loanReferenceId"
      label="Reference ID"
      helpText="Provided by your lender"
      validationData={props.validations}
      formData={props.formData}
      onChange={props.onChange}
      required
      disabled={referenceIdProvided}
    />
  );
};

const generateValidateFormBeforeProceeding = (props) => () => {
  const {
    formData,
    onNext,
    onFormValidated,
    history,
  } = props;
  const validator = new FormValidator(validationConfig);
  const result = validator.validate(formData);
  onFormValidated(result);
  if (result.isInvalid) return;
  onNext(history);
};

const errorMessage = () => (<div>Not Found</div>);

export default function PersonalInfoFormView(props) {
  if (props.config.loading) return <Loader />;
  if (!props.config.dealerIBV || !props.config.dealerIBV.enabled) return errorMessage();
  const { displayName, logo } = props.config.dealerIBV;
  return (
    <div>
      <div className={styles.heading}>
        <h3>{`${displayName || ''} Banking Verification`}</h3>
        <CompanyLogo
          size="large"
          companyLogo={logo}
          clientId={props.clientId}
          companyDisplayName={displayName}
        />
      </div>
      <div className="form-group-wrapper">
        <Container>
          {
            renderClientLoanReferenceId(props)
          }
          <TextInput
            name="firstName"
            label="First Name"
            validationData={props.validations}
            formData={props.formData}
            onChange={props.onChange}
            required
          />
          <TextInput
            name="lastName"
            label="Last Name"
            validationData={props.validations}
            formData={props.formData}
            onChange={props.onChange}
            required
          />
          <TextInput
            name="phone"
            label="Cell Phone"
            validationData={props.validations}
            formData={props.formData}
            onChange={generatePhoneNumberHandler(props.onChange, props.formData.phone)}
            type="tel"
            pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
            maxLength="12"
            helpText="###-###-####"
            required
            onKeyPress={filterNumericKeyPress}
          />
          <TextInput
            name="email"
            label="Email"
            validationData={props.validations}
            formData={props.formData}
            onChange={props.onChange}
            required
          />
          <Button
            onClick={generateValidateFormBeforeProceeding(props)}
          >
            Next
          </Button>
        </Container>
      </div>
    </div>
  );
}
